import GoogleAutoAd from '@/commons/GoogleAutoAd'

export default {
	name: 'score',
	props: {
		score: { type: Object },
		loaded: { default: false },
		achievement: { type: Object, default: () => ({ value: 0, label: 'Total Answered', key: 'total_questions' }) },
		isEnd: { default: false },
		sessionTime: { default: 0 },
		activityTime: { default: null },
		pauseClock: { default: false },
		worksheetLink: { type: String, required: false },
		lessonLink: { type: String, required: false }
	},
	components: { GoogleAutoAd },
	data() {
		return {
			elapsedTime: this.sessionTime,
			achievementValue: this.achievement.value,
		}
	},
	created() {},
	mounted() {
		let clockActivity = setInterval(() => {
			if (document.hidden || this.endOfGame || this.pauseClock) {
			} else {
				this.elapsedTime = this.elapsedTime + 1;
			}
			if (this.remainTime == 0) {
				clearInterval(clockActivity)
			}
			// console.log('1 second passed');
		}, 1000);
	},
	computed: {
		elapsed() {
			let hours = parseInt(this.elapsedTime / 3600), minutes = parseInt((this.elapsedTime % 3600) / 60), seconds = this.elapsedTime % 60;
			return {
				hours: ('00' + hours).slice(-2),
				minutes: ('00' + minutes).slice(-2),
				seconds: ('00' + seconds).slice(-2)
			}
		},
		isRemainedTime() {
			return this.activityTime != null && Number(this.activityTime) == this.activityTime;
		},
		displayTime() {
			let sessionTime = this.isRemainedTime ? this.remainTime : this.elapsedTime,
				hours = parseInt(sessionTime / 3600),
				minutes = parseInt((sessionTime % 3600) / 60),
				seconds = sessionTime % 60;
			return {
				hours: ('00' + hours).slice(-2),
				minutes: ('00' + minutes).slice(-2),
				seconds: ('00' + seconds).slice(-2)
			}
		},
		endOfGame() {
			return this.score.remain == 0;
		},
		remainTime() {
			return (this.activityTime || 5400) - this.elapsedTime;
		},
		exampleLink() {
			return `${this.lessonLink}#example-course`;
		}
	},
	methods: {},
	watch: {
		score(score) {
			switch (this.achievement.key) {
				case 'total_questions':
					this.achievementValue = this.achievement.value + score.passed;
					break;
				default:
					// statements_def
					break;
			}
			this.$emit('time', {elapsed: this.elapsedTime});
		},
		elapsedTime() {
			this.$emit('time', {elapsed: this.elapsedTime});
		},
		endOfGame(val, old) {
			if (val) {
				// this.elapsedTime = 0;
			}
		},
		'score.passed' (val, old) {
			// log('passed questions change from ', old, 'to', val);
			if (val == 0 && old > 0) {
				this.elapsedTime = 0;
			}
		}
	}
}